import React from 'react';
import {
    Paper,
    Typography,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    BottomNavigation,
    BottomNavigationAction,
    useTheme,
    useMediaQuery
} from '@mui/material';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import CardGiftcardOutlinedIcon from '@mui/icons-material/CardGiftcardOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';

const ProfileSettingsNav = ({ activeSection, onSectionChange }) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const navigationItems = [
        {
            id: 'profile-security',
            text: 'Profile & Security',
            icon: <SecurityOutlinedIcon />,
            section: 'profile-security'
        },
        // {
        //     id: 'notifications',
        //     text: 'Notification Settings',
        //     icon: <NotificationsOutlinedIcon />,
        //     section: 'notifications'
        // },
        // {
        //     id: 'subscription',
        //     text: 'Subscription & Billing',
        //     icon: <CardGiftcardOutlinedIcon />,
        //     section: 'subscription'
        // },
        {
            id: 'support',
            text: 'Support & Help',
            icon: <HelpOutlineOutlinedIcon />,
            section: 'support'
        }
    ];
    const companyNavItem = {
        id: 'company-settings',
        text: 'Company Settings',
        icon: <BusinessOutlinedIcon />,
        section: 'company-settings'
    };

    const allNavigationItems = [...navigationItems, companyNavItem];

    return (
        <>
            {/* Desktop Sidebar */}
            <Paper elevation={0}
                sx={{
                    display: { xs: 'none', md: 'block' },
                    p: 2,
                    bgcolor: 'background.paper',
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: '12px',
                    height: 'fit-content'
                }}
            >
                <Typography variant="h6" sx={{
                    fontWeight: 600, mb: 2, color: 'text.primary', fontSize: '0.875rem', lineHeight: 1.2
                }} >  Profile Settings
                </Typography>
 
                <List sx={{ p: 0 }}>
                    {navigationItems.map((item) => {
                        const isActive = activeSection === item.section;
                        return (
                            <ListItem key={item.id} disablePadding sx={{ mb: 0.5 }}>
                                <ListItemButton onClick={() => onSectionChange(item.section)}
                                    sx={{
                                        borderRadius: '8px', py: 1, px: 1.5,
                                        transition: 'all 0.2s ease',
                                        ...(isActive && {
                                            bgcolor: 'rgba(107, 49, 196, 0.06)', color: '#6B31C4',
                                            '& .MuiListItemIcon-root': { color: '#6B31C4' },
                                            '&:hover': { bgcolor: 'rgba(107, 49, 196, 0.08)' }
                                        }),
                                        ...(!isActive && { 
                                            color: 'text.secondary',
                                            '&:hover': { bgcolor: 'action.hover', color: 'text.primary', '& .MuiListItemIcon-root': { color: 'text.primary' } } 
                                        })
                                    }}
                                >
                                    <ListItemIcon sx={{ color: isActive ? '#6B31C4' : 'text.secondary', minWidth: 30, '& .MuiSvgIcon-root': { fontSize: 20 } }}   >
                                        {item.icon}
                                    </ListItemIcon>
                                    <ListItemText primary={item.text}
                                        primaryTypographyProps={{ fontSize: '0.8125rem', fontWeight: isActive ? 600 : 500 }}
                                    />
                                </ListItemButton>
                            </ListItem>
                        );
                    })}
                </List>
 
                <Typography variant="h6"
                    sx={{ fontWeight: 600, mt: 3, mb: 2, color: 'text.primary', fontSize: '0.875rem' }}
                >
                    Company Settings
                </Typography>
 
                <List sx={{ p: 0 }}>
                    <ListItem disablePadding sx={{ mb: 0.5 }}>
                        <ListItemButton onClick={() => onSectionChange('company-settings')}
                            sx={{
                                borderRadius: '8px', py: 1, px: 1.5,
                                transition: 'all 0.2s ease',
                                ...(activeSection === 'company-settings' && {
                                    bgcolor: 'rgba(107, 49, 196, 0.06)', color: '#6B31C4',
                                    '& .MuiListItemIcon-root': { color: '#6B31C4' },
                                    '&:hover': { bgcolor: 'rgba(107, 49, 196, 0.08)' }
                                }),
                                ...(activeSection !== 'company-settings' && { 
                                    color: 'text.secondary',
                                    '&:hover': { bgcolor: 'action.hover', color: 'text.primary', '& .MuiListItemIcon-root': { color: 'text.primary' } } 
                                })
                            }}
                        >
                            <ListItemIcon sx={{ color: activeSection === 'company-settings' ? '#6B31C4' : 'text.secondary', minWidth: 30, '& .MuiSvgIcon-root': { fontSize: 20 } }}>
                                <BusinessOutlinedIcon />
                            </ListItemIcon>
                            <ListItemText primary="Company Settings"
                                primaryTypographyProps={{ fontSize: '0.8125rem', fontWeight: activeSection === 'company-settings' ? 600 : 500 }}
                            />
                        </ListItemButton>
                    </ListItem>
                </List>
            </Paper>

            {/* Mobile Bottom Navigation */}
            {!isDesktop && (
                <Paper elevation={3}
                    sx={{
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        zIndex: theme.zIndex.appBar + 1,
                        display: { xs: 'block', md: 'none' }
                    }}
                >
                    <BottomNavigation
                        showLabels
                        value={activeSection}
                        onChange={(event, newValue) => onSectionChange(newValue)}
                    >
                        {allNavigationItems.map(item => (
                            <BottomNavigationAction
                                key={item.id}
                                label={item.text}
                                icon={item.icon}
                                value={item.section}
                            />
                        ))}
                    </BottomNavigation>
                </Paper>
            )}
        </>
    );
};

export default ProfileSettingsNav;

